<template>
    <span>{{format()}}</span>
</template>

<script>
import moment from 'moment';
export default {
    name: "DateRender",
    props: {
        value: Number|String,
        separator: {
            type: String,
            default: '-'
        }
    },
    data()
    {
        return {}
    },
    methods:
    {
        format()
        {
            if(!this.value) return '-';
            return moment(this.value).format(`YYYY${this.separator}MM${this.separator}DD`);
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render/DateRender.vue